import { AggregateRoot } from "../value_objects/aggregate_root";
import type { TaskProps } from "../value_objects/task_props";
import { TaskStatus } from "../value_objects/task_status";
import type { UniqueEntityID } from "../value_objects/unique_entity_Id";


// Aggregate Root
export class Task extends AggregateRoot<TaskProps> {
    private constructor(props: TaskProps, id?: UniqueEntityID) {
        super(props, id);
    }

    // ✅ Factory method
    static create(props: TaskProps, id?: UniqueEntityID): Task {
        return new Task(props, id);
    }

    // ✅ Getters
    get taskId(): string {
        return this._id.toValue();
    }

    get status(): TaskStatus {
        return this.props.status;
    }

    get pascoId(): string {
        return this.props.pascoId;
    }

    get errorMessage(): string | null | undefined {
        return this.props.errorMessage;
    }

    get attemptCount(): number {
        return this.props.attemptCount;
    }

    get createdAt(): Date {
        return this.props.createdAt;
    }

    get updatedAt(): Date {
        return this.props.updatedAt;
    }

    // ✅ Domain behaviors
    markAsCompleted(): void {
        this.props.status = TaskStatus.Completed;
        this.touch();
    }

    markAsFailed(error: string): void {
        this.props.status = TaskStatus.Failed;
        this.props.errorMessage = error;
        this.touch();
    }

    incrementAttemptCount(): void {
        this.props.attemptCount += 1;
        this.touch();
    }

    private touch(): void {
        this.props.updatedAt = new Date();
    }
}
